import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

import App from './App.vue'
import router from './router'
import { queryClient } from './lib/query'
import { initSentry } from './lib/sentry'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

// Sentry must be initialised first so it instruments everything below
initSentry(app, router)

app.use(pinia)
app.use(router)
app.use(VueQueryPlugin, { queryClient })

app.mount('#app')
